import { Box, Typography, Stack, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ShPaper } from 'shared/SharedStyles/ShSurfaces';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import SecurityIcon from '@mui/icons-material/Security';
import AnalyticsIcon from '@mui/icons-material/Analytics';

export const EmailCampaignHelp = () => {

  return (
    <ShPaper variant='outlined'>
      <Stack spacing={4} mt={3}>
        <Box>
          <Stack direction="row" spacing={2} alignItems="center">
            <EmailIcon color="primary" sx={{ fontSize: 40 }} />
            <Typography variant="h5">Email Campaign Help Guide</Typography>
          </Stack>
          <Typography variant="body1" color="text.secondary" mt={2}>
            Learn how to effectively use email campaigns to engage with your candidates and streamline your hiring process.
          </Typography>
        </Box>

        <ShPaper variant="outlined">
          <Typography variant="h6" gutterBottom>Getting Started</Typography>
          <List>
            <ListItem>
              <ListItemIcon><CheckCircleOutlineIcon color="primary" /></ListItemIcon>
              <ListItemText 
                primary="Create Your First Campaign"
                secondary="Click the 'Create Campaign' button to start. You'll need to provide a subject line, recipient list, and email content."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleOutlineIcon color="primary" /></ListItemIcon>
              <ListItemText 
                primary="Preview Before Sending"
                secondary="Always preview your campaign to ensure formatting is correct and all links work properly."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleOutlineIcon color="primary" /></ListItemIcon>
              <ListItemText 
                primary="Track Performance"
                secondary="Monitor open rates, click rates, and engagement metrics after sending your campaign."
              />
            </ListItem>
          </List>
        </ShPaper>

        <ShPaper variant="outlined">
          <Typography variant="h6" gutterBottom>Best Practices</Typography>
          <List>
            <ListItem>
              <ListItemIcon><TipsAndUpdatesIcon color="warning" /></ListItemIcon>
              <ListItemText 
                primary="Personalization"
                secondary="Use candidate names and specific details to make emails more engaging and relevant."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><TipsAndUpdatesIcon color="warning" /></ListItemIcon>
              <ListItemText 
                primary="Clear Call-to-Action"
                secondary="Include clear instructions on what you want candidates to do next."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><TipsAndUpdatesIcon color="warning" /></ListItemIcon>
              <ListItemText 
                primary="Mobile Optimization"
                secondary="Ensure your email content is readable on mobile devices."
              />
            </ListItem>
          </List>
        </ShPaper>

        <ShPaper variant="outlined">
          <Typography variant="h6" gutterBottom>Compliance & Security</Typography>
          <List>
            <ListItem>
              <ListItemIcon><SecurityIcon color="info" /></ListItemIcon>
              <ListItemText 
                primary="Data Protection"
                secondary="Always comply with data protection regulations and only use candidate data for intended purposes."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><SecurityIcon color="info" /></ListItemIcon>
              <ListItemText 
                primary="Opt-out Options"
                secondary="Include clear unsubscribe options in all campaign emails."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><SecurityIcon color="info" /></ListItemIcon>
              <ListItemText 
                primary="Consent Management"
                secondary="Only send emails to candidates who have explicitly opted in to receive communications."
              />
            </ListItem>
          </List>
        </ShPaper>

        <ShPaper variant="outlined">
          <Typography variant="h6" gutterBottom>Analytics & Metrics</Typography>
          <List>
            <ListItem>
              <ListItemIcon><AnalyticsIcon color="success" /></ListItemIcon>
              <ListItemText 
                primary="Open Rates"
                secondary="Track how many candidates are opening your emails to measure engagement."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><AnalyticsIcon color="success" /></ListItemIcon>
              <ListItemText 
                primary="Click Rates"
                secondary="Monitor which links and content are generating the most interest."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><AnalyticsIcon color="success" /></ListItemIcon>
              <ListItemText 
                primary="Response Times"
                secondary="Analyze when candidates are most likely to engage with your emails."
              />
            </ListItem>
          </List>
        </ShPaper>

        <ShPaper variant="outlined">
          <Typography variant="h6" gutterBottom>Common Issues & Solutions</Typography>
          <List>
            <ListItem>
              <ListItemIcon><WarningAmberIcon color="error" /></ListItemIcon>
              <ListItemText 
                primary="Low Open Rates"
                secondary="Try improving subject lines, sending at optimal times, and ensuring sender name is recognizable."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><WarningAmberIcon color="error" /></ListItemIcon>
              <ListItemText 
                primary="High Unsubscribe Rates"
                secondary="Review email frequency, content relevance, and ensure emails provide value to recipients."
              />
            </ListItem>
            <ListItem>
              <ListItemIcon><WarningAmberIcon color="error" /></ListItemIcon>
              <ListItemText 
                primary="Delivery Issues"
                secondary="Maintain a clean email list, avoid spam trigger words, and follow email best practices."
              />
            </ListItem>
          </List>
        </ShPaper>
      </Stack>
    </ShPaper>
  );
}; 